var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"chart-card",attrs:{"elevation":"0"}},[_c('v-card-title',{staticClass:"title-card-chart"},[_vm._v("Total Realizado")]),_c('v-card-text',[_c('Chart',{attrs:{"chartOptions":_vm.chartOptions}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }